import React from 'react';
import { H2, P, UL, LI, Callout } from './_shared';

export default {
  slug: 'health-score',
  title: 'Understanding folder health',
  category: 'ai',
  summary: 'A 0–100 score for "is this deal on track" based on five factors. How it\'s calculated and what to do about a red folder.',
  searchTerms: ['health', 'score', 'ai', 'risk', 'red folder', 'engagement'],
  related: ['folders-intro', 'broker-dashboard'],
  Body: () => (
    <>
      <P>
        Folder health is the AI's at-a-glance read on whether a deal is on
        track or sliding. It's a 0–100 score with a color band — green
        (75+), amber (40–74), coral (under 40).
      </P>

      <H2>The five factors</H2>
      <UL>
        <LI><strong>Client engagement</strong> — recency and depth of two-way activity (emails opened, calls returned, appointments kept).</LI>
        <LI><strong>Document velocity</strong> — how quickly docs move from draft → sent → signed vs. the median for this deal type.</LI>
        <LI><strong>Timeline pressure</strong> — days remaining to close vs. unresolved milestones.</LI>
        <LI><strong>Compliance coverage</strong> — % of required docs uploaded for your jurisdiction.</LI>
        <LI><strong>Signer responsiveness</strong> — average time to sign for outstanding envelopes.</LI>
      </UL>

      <H2>What the AI suggests when it goes red</H2>
      <P>
        Each factor has a specific remediation. Click the score on the folder
        page to see "what to do next" — usually a draft email, a phone-call
        prompt, or a missing-doc nudge for the signer. The same suggestion
        text powers the "✨ Draft email with AI" button.
      </P>

      <Callout kind="info">
        Health scores recompute every 15 minutes and on key events
        (envelope completed, doc uploaded, stage changed). If you've just
        fixed something, refresh to see the new score.
      </Callout>
    </>
  ),
};
